import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Edit2 } from 'lucide-react';

const CATEGORY_LABELS = {
  auth: 'Authentication',
  shop: 'Shop & Orders',
  investment: 'Investments & KYC',
  wholesale: 'Wholesale (B2B)',
};

const CATEGORY_COLORS = {
  auth: 'bg-blue-50 text-blue-700 border-blue-200',
  shop: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  investment: 'bg-amber-50 text-amber-700 border-amber-200',
  wholesale: 'bg-purple-50 text-purple-700 border-purple-200',
};

const TemplateList = ({ templates, onSelect }) => {
  const byCategory = templates.reduce((acc, t) => {
    const cat = t.category || 'other';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(t);
    return acc;
  }, {});

  return (
    <div className="space-y-8" data-testid="template-list">
      {Object.entries(byCategory).map(([cat, list]) => (
        <div key={cat}>
          <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
            {CATEGORY_LABELS[cat] || cat}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {list.map((t) => (
              <Card
                key={t.key}
                className="cursor-pointer hover:shadow-md hover:border-green-300 transition-all"
                onClick={() => onSelect(t.key)}
                data-testid={`template-card-${t.key}`}
              >
                <CardContent className="p-4">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <h3 className="font-semibold text-sm">{t.name}</h3>
                    <span
                      className={`text-[10px] px-2 py-0.5 rounded-full border ${
                        CATEGORY_COLORS[t.category] || 'bg-gray-50 text-gray-700 border-gray-200'
                      }`}
                    >
                      v{t.version}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 line-clamp-2 mb-3">{t.description}</p>
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-400 font-mono">{t.key}</span>
                    <span className="flex items-center gap-1 text-green-700">
                      <Edit2 className="h-3 w-3" /> Edit
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TemplateList;
